import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'es', flag: '🇨🇴', ariaKey: 'language.switchToSpanish' },
    { code: 'en', flag: '🇬🇧', ariaKey: 'language.switchToEnglish' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-selector-flags" role="group" aria-label="Select language">
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          className={`language-flag-btn ${i18n.language?.startsWith(lang.code) ? 'active' : ''}`}
          onClick={() => changeLanguage(lang.code)}
          aria-label={t(lang.ariaKey)}
          aria-pressed={i18n.language?.startsWith(lang.code)}
          title={t(lang.ariaKey)}
        >
          <span className="language-flag-emoji" aria-hidden="true">{lang.flag}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
